export const apiStatuses = {
  success: "success",
  failure: "failure",
}

export const loadingStatuses = {
  idle: "idle",
  loading: "loading",
}
